import isEqual from '@tinkoff/utils/is/equal'
import map from '@tinkoff/utils/object/map'
import { AnyBreakpoints } from 'application/theme'
import { useEffect, useState } from 'react'

export const useScrollToActiveCard = ({ breakpoints }: { breakpoints: AnyBreakpoints<number> | number }) => {
  const [activeCardsIndexes, setActiveCardsIndexes] = useState<number[]>([])
  const [groupToScroll, setGroupToScroll] = useState<AnyBreakpoints<number> | number>(0)

  useEffect(() => {
    if (activeCardsIndexes.length === 1) {
      if (typeof breakpoints === 'number') {
        setGroupToScroll(Math.floor(activeCardsIndexes[0] / breakpoints))
      } else {
        setGroupToScroll(
          map((slidesPerPage) => {
            if (slidesPerPage !== undefined) {
              return Math.floor(activeCardsIndexes[0] / slidesPerPage)
            } else {
              return 0
            }
          }, breakpoints)
        )
      }
    }
  }, [activeCardsIndexes, breakpoints])

  const onActiveChangeHandler = (index: number) => (isActive: boolean) => {
    setActiveCardsIndexes((activeCardsIndexes) => {
      let newValue: number[]
      if (isActive) {
        newValue = activeCardsIndexes.indexOf(index) === -1 ? [...activeCardsIndexes, index] : activeCardsIndexes
      } else {
        newValue = activeCardsIndexes.filter((item) => item !== index)
      }

      if (isEqual(newValue, activeCardsIndexes)) {
        return activeCardsIndexes
      } else {
        return newValue
      }
    })
  }

  return { groupToScroll, onActiveChangeHandler }
}
